import { createSlice } from "@reduxjs/toolkit";
import { fetchUserById, fetchUsers, updateUser } from "../thunks/userThunks";

const initialState = {
  users: {},
  list: [],
  current: null,
  usersById: {},
  loading: false,
  error: null,
  hasFetched: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUser: () => initialState,
    clearUserError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // ========================
      // FETCH USER BY ID
      // ========================
      .addCase(fetchUserById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
     .addCase(fetchUserById.fulfilled, (state, action) => {
  state.loading = false;
  state.isAuth = true;
  state.hasFetched = true;

  if (action.payload?.id) {
    state.users[action.payload.id] = action.payload;
  }
})
      .addCase(fetchUserById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // FETCH ALL USERS
      // ========================
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
.addCase(fetchUsers.fulfilled, (state, action) => {
  state.loading = false;
  state.hasFetched = true;
  state.usersById = {};

  if (Array.isArray(action.payload)) {
    action.payload.forEach(user => {
      if (user?.id) {
        state.usersById[user.id] = user; // ✅ fixed
      }
    });
  }
})

      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ========================
      // UPDATE USER
      // ========================
      .addCase(updateUser.fulfilled, (state, action) => {
        const user = action.payload;
        if (!user?.id) return;

        const mergedUser = {
          ...(state.users[user.id] || state.usersById[user.id] || {}),
          ...user,
        };

        state.users[user.id] = mergedUser;
        state.usersById[user.id] = mergedUser;
        state.current = mergedUser;

        const index = state.list.findIndex((u) => u.id === user.id);
        if (index !== -1) {
          state.list[index] = mergedUser;
        }
      });
  },
});

export const { resetUser, clearUserError } = userSlice.actions;
export default userSlice.reducer;

